import axios from "axios";
import {
  ConvertRewardsToUsdRequest,
  ConvertRewardsToUsdResponse,
} from "redmond";

import { config } from "../../config";

import { rewardsApiPrefix } from "../paths";

const END_POINT: string = `${rewardsApiPrefix}/convert/redeem/rewardsToUsd`;

export const convertRewardsAmountToUsd = (
  request: ConvertRewardsToUsdRequest
): Promise<ConvertRewardsToUsdResponse> =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await axios.put(END_POINT, request, {
        baseURL: config.baseURL,
      });

      resolve(res.data);
    } catch (e) {
      reject(e);
    }
  });
